import { render } from "./artigoTransferViatura.vue?vue&type=template&id=150df922&scoped=true"
import script from "./artigoTransferViatura.vue?vue&type=script&lang=js"
export * from "./artigoTransferViatura.vue?vue&type=script&lang=js"

import "./artigoTransferViatura.vue?vue&type=style&index=0&id=150df922&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-150df922"]])

export default __exports__